
import AppRow from "./SaleInfoTableRow.vue";
import AppProductsTableInfoHead from "./SaleInfoTableHead.vue";
import Vue from "vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { TranslateResult } from "vue-i18n";
import { UserConfigService } from "@/services/user-config-service";
import {Sale, SaleRow} from "@/models/base";
import { SaleConfigs } from "@/models/dossier-configs/sale-configs";

export default Vue.extend({
	data(){
		return {
			storedWidths: {} as {[index:string]:number},
			DossierConfigService
		};
	},
	props: {
		items: Array as () => SaleRow[],
		sale: Object as () => Sale,
		useQty2: Boolean
	},
	computed: {
		minimumWidths():({[index:string]:number}){
			return this.getDefaultWidths();
		},
		unitLabel():string | TranslateResult {
			let name = DossierConfigService.getGeneralConfig().UnitFieldName;
			if (name){
				return name;
			}
			return this.$ct("sales-row.Unit");
		},
		hideUnits():Boolean {
			return !UserConfigService.getSaleSettings().ShowUnits;
		},
		saleConfigs():SaleConfigs{
			return this.DossierConfigService.getSaleConfigs();
		},
		showQty2():boolean{
			return this.saleConfigs.UseQty2;
		},
		qty2Label():TranslateResult | string{
			if (this.saleConfigs.Qty2Label){
				return this.saleConfigs.Qty2Label;
			}
			return this.$ct("sales-row.Qty2");
		}
	},
	watch: {
		storedWidths: {
			deep: true,
			handler(){
				this.saveWidths();
			}
		}
	},
	methods: {
		loadWidths(){
			let widths = this.getDefaultWidths();
			let storedWidthsString = localStorage.getItem("sale-info-widths");
			if (storedWidthsString) {
				let storedWidths = JSON.parse(storedWidthsString);
				let defaultWidhts = this.getDefaultWidths();
				Object.keys(widths).forEach((key)=>{
					if (storedWidths[key] && storedWidths[key] > defaultWidhts[key]) {
						widths[key] = storedWidths[key];
					}
				});
			}
			this.storedWidths = widths;
		},
		getDefaultWidths():({[index:string]:number}){
			return {
				"qty": 80,
				"qty2": 80,
				"sku": 80,
				"unit": 80,
				"unit-price": 85,
				"discount": 60,
				"vat": 50,
				"netto": 85,
				"bruto": 85
			};
		},
		setMinimumWidths(widths:{[index:string]:number}){
			let defaultWidhts = this.getDefaultWidths();
			Object.keys(widths).forEach((key)=>{
				if (defaultWidhts[key] > defaultWidhts[key]) {
					widths[key] = defaultWidhts[key];
				}
			});
		},
		saveWidths(){
			localStorage.setItem("sale-info-widths", JSON.stringify(this.storedWidths));
		}
	},
	created(){
		this.loadWidths();
	},
	components: {
		AppRow,
		AppProductsTableInfoHead
	},
	i18nEx: {
		componentPrefix: "components.products-table"
	}
});
